import React from 'react';

export const CustomPlanDescription = () => (
  <p className="center mt-25">
    If you have a large team, high message volumes, multiple phone numbers,
    toll-free or short code numbers, advanced integrations, security
    requirements, and need dedicated support, contact us to discuss the
    best plan for your company.
  </p>
);
